import axios from "axios";

export let headers = {
  "Tenant-Access-Token": "ZWZhOTdlOGM1N2Q1MDVjZmIyYTZkZTZkYTM5OTg3OTM=",
  "Tenant-Access-Key": "LkISszPHYLdKoQ",
};

export const api = axios.create({
  baseURL: "https://immersive-game-india.confirmu.com",
  headers: {
    "Tenant-Access-Token": "ZWZhOTdlOGM1N2Q1MDVjZmIyYTZkZTZkYTM5OTg3OTM=",
    "Tenant-Access-Key": "LkISszPHYLdKoQ",
  },
});

export const BASE_URL = "https://immersive-game-india.confirmu.com";
